"use client"

import { useRouter } from "next/navigation"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"

export function NavbarSearch() {
  const router = useRouter()

  const navigateToSearch = () => {
    router.push("/search")
  }

  return (
    <div className="px-2 py-2">
      <button
        onClick={navigateToSearch}
        className="flex h-6 w-6 items-center justify-center text-gray-500 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        aria-label="Search"
        type="button"
      >
        <MagnifyingGlassIcon className="h-5 w-5" />
      </button>
    </div>
  )
}
